const detect = require('./detect');

(($) => {

    $.fn.warnMSIEWin10 = function () {
        if (detect.ie() && detect.windows() === 10) {
            console.log('detected MSIE on Windows 10');
            return this.modal('show');
        }
        else {
            return this;
        }
    };

})(jQuery);
